module.exports = {
	"is_by_homeowner": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_bowling": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_shopping_area": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_video": {
		"required": false,
		"type": "term",
		"value": null
	},
	"include_new_moscow": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_exhibition_and_warehouse_complex": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_cafe": {
		"required": false,
		"type": "term",
		"value": null
	},
	"water_possible_to_connect": {
		"required": false,
		"type": "term",
		"value": null
	},
	"realty_user_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_furniture": {
		"required": false,
		"type": "term",
		"value": null
	},
	"property_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"land_status2": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_hotel": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building_class_type__warehouse": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"building_house_line_type__shopping_area": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_pharmacy": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_automatic_gates": {
		"required": false,
		"type": "term",
		"value": null
	},
	"company_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_aquapark": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_minimarket": {
		"required": false,
		"type": "term",
		"value": null
	},
	"lk_offer_statuses": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"has_investment_project": {
		"required": false,
		"type": "term",
		"value": null
	},
	"drainage_location_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"saved_search_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"bs_center": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_restaurant": {
		"required": false,
		"type": "term",
		"value": null
	},
	"description_include": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"sub_agent_ids": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"bbox": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building_house_line_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"building_cranage_types_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_cinema": {
		"required": false,
		"type": "term",
		"value": null
	},
	"geo": {
		"required": false,
		"type": "geo",
		"value": null
	},
	"infrastructure_has_car_service": {
		"required": false,
		"type": "term",
		"value": null
	},
	"categories": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_medical_center": {
		"required": false,
		"type": "term",
		"value": null
	},
	"condition_type__industry": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_atm": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_studio": {
		"required": false,
		"type": "term",
		"value": null
	},
	"drainage_possible_to_connect": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_price_reduced": {
		"required": false,
		"type": "term",
		"value": null
	},
	"multi_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_manual": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building_lift_types_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"security": {
		"required": false,
		"type": "term",
		"value": null
	},
	"page": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building_type2": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"good_ecology": {
		"required": false,
		"type": "term",
		"value": null
	},
	"creation_date": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"infrastructure_has_entry_by_pass": {
		"required": false,
		"type": "term",
		"value": null
	},
	"parking": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_water": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_electricity": {
		"required": false,
		"type": "term",
		"value": null
	},
	"category": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"random_sort": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_slot_machines": {
		"required": false,
		"type": "term",
		"value": null
	},
	"input_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"has_extinguishing_system": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_buffet": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_tire": {
		"required": false,
		"type": "term",
		"value": null
	},
	"with_corpuses": {
		"required": false,
		"type": "term",
		"value": null
	},
	"garage_garage_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_clothes_studio": {
		"required": false,
		"type": "term",
		"value": null
	},
	"internet": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_office_space": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_rink": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_light": {
		"required": false,
		"type": "term",
		"value": null
	},
	"only_foot": {
		"required": false,
		"type": "term",
		"value": null
	},
	"water_location_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"offset": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_central_reception": {
		"required": false,
		"type": "term",
		"value": null
	},
	"from_offrep": {
		"required": false,
		"type": "term",
		"value": null
	},
	"permitted_use_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"region": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"not_last_floor": {
		"required": false,
		"type": "term",
		"value": null
	},
	"contract": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"is_basement": {
		"required": false,
		"type": "term",
		"value": null
	},
	"show_inactive": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building_type__building": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"builders_ids": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"publish_period": {
		"required": false,
		"type": "term",
		"value": null
	},
	"developer_sort_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"foot_min": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"cl": {
		"required": false,
		"type": "term",
		"value": null
	},
	"wp": {
		"required": false,
		"type": "term",
		"value": null
	},
	"floorn": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"condition_type__free_appointment_object": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"garage_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"is_semibasement": {
		"required": false,
		"type": "term",
		"value": null
	},
	"from_mcad_km": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"add_phones": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building_class_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"quality": {
		"required": false,
		"type": "term",
		"value": false
	},
	"infrastructure_has_hour_security": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_video_surveillance": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_bank_department": {
		"required": false,
		"type": "term",
		"value": null
	},
	"gas_location_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_basement": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_car_wash": {
		"required": false,
		"type": "term",
		"value": null
	},
	"condition_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"house_year": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"infrastructure_has_game_room": {
		"required": false,
		"type": "term",
		"value": null
	},
	"sort": {
		"required": false,
		"type": "term",
		"value": null
	},
	"house_class": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"status_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"description_exclude": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"price_sm": {
		"required": false,
		"type": "term",
		"value": null
	},
	"office_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"precision": {
		"required": false,
		"type": "term",
		"value": null
	},
	"phone": {
		"required": false,
		"type": "term",
		"value": null
	},
	"lift": {
		"required": false,
		"type": "term",
		"value": null
	},
	"garage_status": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_pool": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_beauty_shop": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_notary_office": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_fitness_centre": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_inspection_pit": {
		"required": false,
		"type": "term",
		"value": null
	},
	"id_user": {
		"required": false,
		"type": "term",
		"value": null
	},
	"room": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"bs_center_id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"specialty_types": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"placement_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"limit": {
		"required": false,
		"type": "term",
		"value": null
	},
	"possible_to_change_permitted_use_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"driveway_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_food_court": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_dop_phone_lines": {
		"required": false,
		"type": "term",
		"value": null
	},
	"bs_center_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_supermarket": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building_gates_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"total_area": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"site": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"garage_material": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"currency": {
		"required": false,
		"type": "term",
		"value": 2
	},
	"phone_lines_count": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"has_heating": {
		"required": false,
		"type": "term",
		"value": null
	},
	"id": {
		"required": false,
		"type": "term",
		"value": null
	},
	"skipids": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"building_heating_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_baby_sitting": {
		"required": false,
		"type": "term",
		"value": null
	},
	"floor": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"realty_sort_type": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_park": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"enable_autotest_offers": {
		"required": false,
		"type": "term",
		"value": null
	},
	"infrastructure_has_conference_room": {
		"required": false,
		"type": "term",
		"value": null
	},
	"commerce_rooms": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"with_layout": {
		"required": false,
		"type": "term",
		"value": null
	},
	"_type": "commercialsale",
	"newbuildings_search": {
		"required": false,
		"type": "term",
		"value": null
	},
	"electricity_possible_to_connect": {
		"required": false,
		"type": "term",
		"value": null
	},
	"rent_period_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"price": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"ceiling_height": {
		"required": false,
		"type": "range",
		"value": {
			"gte": null,
			"lte": null
		}
	},
	"estate_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"is_first_floor": {
		"required": false,
		"type": "term",
		"value": null
	},
	"with_neighbors": {
		"required": false,
		"type": "term",
		"value": null
	},
	"electricity_location_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_canteen": {
		"required": false,
		"type": "term",
		"value": null
	},
	"is_in_hidden_base": {
		"required": false,
		"type": "term",
		"value": null
	},
	"building": {
		"required": false,
		"type": "term",
		"value": null
	},
	"parking_type": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"infrastructure_has_warehouse": {
		"required": false,
		"type": "term",
		"value": null
	},
	"gas_possible_to_connect": {
		"required": false,
		"type": "term",
		"value": null
	},
	"engine_version": {
		"required": false,
		"type": "term",
		"value": 2
	},
	"land_possible_to_change_status": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_equipment": {
		"required": false,
		"type": "term",
		"value": null
	},
	"contact": {
		"required": false,
		"type": "term",
		"value": null
	},
	"billing_package_region_id": {
		"required": false,
		"type": "terms",
		"value": null
	},
	"my_offers_search_text": {
		"required": false,
		"type": "term",
		"value": null
	},
	"enter": {
		"required": false,
		"type": "term",
		"value": null
	},
	"has_encumbrances": {
		"required": false,
		"type": "term",
		"value": null
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/serp/autogenerated-default-filters/commercialsale.json
// module id = 507
// module chunks = 0